import React from 'react';
type Props = {
  title: string;
  intro?: string;
  tone?: 'light' | 'dark';
  align?: 'left' | 'center';
};
export function SectionHeading({
  title,
  intro,
  tone = 'light',
  align = 'left'
}: Props) {
  const isDark = tone === 'dark';
  return <div className={align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-190" data-mp="3f2wxvnuzz3xr">
      <h2 className={`font-display text-3xl font-extrabold leading-tight sm:text-4xl ${isDark ? 'text-bone' : 'text-ink-900'}`} data-id="element-191" data-mp="3k0p0pcx6kagq">
        {title}
      </h2>
      {intro && <p className={`mt-4 text-base leading-relaxed ${isDark ? 'text-ink-500' : 'text-ink-600'}`} data-id="element-192" data-mp="giooflkldixb">
          {intro}
        </p>}
    </div>;
}